import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ErrorDialogComponent } from './error-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { map, take } from 'rxjs/operators';

@Injectable()
export class ErrorDialogService {
  constructor(private dialog: MatDialog) {}

  dialogRef: MatDialogRef<ErrorDialogComponent>;

  public open(options) {
    this.dialogRef = this.dialog.open(ErrorDialogComponent, {
      data: {
        title: options.title,
        message: options.message,
      },
    });
  }

  public confirmed(): Observable<any> {
    return this.dialogRef.afterClosed().pipe(
      take(1),
      map((res) => {
        return res;
      })
    );
  }
}
